import { defineComponent as H, computed as J, ref as K, useSlots as O, openBlock as l, createElementBlock as n, normalizeClass as t, createTextVNode as Q, toDisplayString as c, unref as o, createBlock as f, withModifiers as P, createCommentVNode as a, renderSlot as m, createElementVNode as R, mergeProps as L, withDirectives as W, vModelDynamic as X } from "vue";
import { _ as b } from "../Icon.vue_vue_type_script_setup_true_lang-BMhFqNxf.js";
import { _ as Y } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../TextField.css';const Z = ["for"], x = { key: 0 }, _ = { key: 1 }, ee = ["id", "type", "placeholder", "aria-placeholder", "aria-labelledby", "disabled"], le = { key: 3 }, oe = { key: 1 }, se = /* @__PURE__ */ H({
  __name: "TextField",
  props: {
    size: { default: "medium" },
    label: { default: "" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    type: { default: "text" },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: { default: "" },
    helperText: { default: "" },
    trailingIcon: { default: "" },
    endIcon: { default: "" },
    classes: { default: () => ({}) },
    pill: { type: Boolean, default: !1 },
    toolTipIcon: { default: "information-circle-icon" },
    showToolTipIcon: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "onTrailingIconClick", "onEndIconClick", "onTooltipClick"],
  setup(U, { emit: j }) {
    const q = U, d = j, u = J({
      get: () => q.modelValue,
      set: (e) => d("update:modelValue", e)
    }), p = K(!1), A = () => {
      p.value = !0;
    }, G = () => p.value = !1, r = O();
    return (e, s) => {
      var y, I, k, v, g, T, h, $, C, S, B, w, V, z, F, E, D, N, M;
      return l(), n("div", {
        class: t(["relative w-full items-stretch", e.$attrs.class, (y = e.classes) == null ? void 0 : y.container])
      }, [
        e.label ? (l(), n("label", {
          key: 0,
          for: e.id,
          class: t(["label", e.success && !e.disabled ? "success-label" : e.error && !e.disabled ? "error-label" : "default-label", (I = e.classes) == null ? void 0 : I.label])
        }, [
          Q(c(e.label) + " ", 1),
          e.showToolTipIcon && !((k = o(r)) != null && k.tooltip) ? (l(), f(o(b), {
            key: 0,
            name: e.toolTipIcon,
            size: "15",
            class: t(["ml-1 cursor-pointer w-[15px]", ((v = e.classes) == null ? void 0 : v.toolTipIcon) || ""]),
            onClick: s[0] || (s[0] = P((i) => d("onTooltipClick"), ["stop"]))
          }, null, 8, ["name", "class"])) : a("", !0),
          e.showToolTipIcon && ((g = o(r)) != null && g.tooltip) ? m(e.$slots, "tooltip", { key: 1 }, void 0, !0) : a("", !0)
        ], 10, Z)) : a("", !0),
        R("div", {
          class: t([
            "relative flex items-center",
            e.success ? "success-container" : e.error ? "error-container" : "default-container",
            e.pill ? "rounded-full" : "rounded-lg",
            `size-${e.size}`,
            p.value ? e.success ? "success-container-focus" : e.error ? "error-container-focus" : "default-container-focus" : "",
            e.disabled && (((T = e.classes) == null ? void 0 : T.disabled) || "disabled-input"),
            (h = e.classes) == null ? void 0 : h.inputContainer
          ])
        }, [
          e.trailingIcon || ($ = o(r)) != null && $.trailingIconSlot ? (l(), n("div", x, [
            e.trailingIcon && !((C = o(r)) != null && C.trailingIconSlot) ? (l(), f(o(b), {
              key: 0,
              name: e.trailingIcon,
              class: t(["icon mr-2 cursor-pointer", ((S = e.classes) == null ? void 0 : S.trailingIcon) || ""]),
              onClick: s[1] || (s[1] = (i) => d("onTrailingIconClick"))
            }, null, 8, ["name", "class"])) : a("", !0),
            (B = o(r)) != null && B.trailingIconSlot ? (l(), n("span", _, [
              m(e.$slots, "trailingIconSlot", {}, void 0, !0)
            ])) : a("", !0)
          ])) : a("", !0),
          (w = e.$attrs) != null && w.isSelect ? (l(), n("button", L({
            key: 1,
            type: "button",
            class: [
              "appearance-none bg-transparent outline-none border-0 w-full flex items-center flex-1 truncate",
              { "text-app-gray-500 dark:text-app-gray-400": !u.value && !e.error && !e.success }
            ]
          }, { ...e.$attrs, class: "", style: {} }, {
            onClick: s[2] || (s[2] = //@ts-ignore
            (...i) => e.$attrs.click && e.$attrs.click(...i))
          }), c(`${u.value || e.placeholder}`), 17)) : W((l(), n("input", L({
            key: 2,
            id: e.id,
            "onUpdate:modelValue": s[3] || (s[3] = (i) => u.value = i),
            role: "textbox",
            type: e.type,
            placeholder: e.placeholder,
            "aria-placeholder": e.placeholder || "TextField Placeholder",
            "aria-labelledby": e.label || "TextField Label",
            disabled: e.disabled,
            class: [
              `size-input-${e.size}`,
              e.pill ? "rounded-full" : "rounded-lg",
              e.success ? "success-input" : e.error ? "error-input" : "default-input",
              "input-root",
              e.disabled && (((V = e.classes) == null ? void 0 : V.disabled) || "disabled-input"),
              (z = e.classes) == null ? void 0 : z.input
            ]
          }, { ...e.$attrs, class: "", style: {} }, {
            onFocus: A,
            onBlur: G
          }), null, 16, ee)), [
            [X, u.value]
          ]),
          e.endIcon || (F = o(r)) != null && F.endIconSlot ? (l(), n("div", le, [
            e.endIcon && !((E = o(r)) != null && E.endIconSlot) ? (l(), f(o(b), {
              key: 0,
              name: e.endIcon,
              class: t(["icon ml-2 cursor-pointer", ((D = e.classes) == null ? void 0 : D.endIcon) || ""]),
              onClick: s[4] || (s[4] = P((i) => d("onEndIconClick"), ["stop"]))
            }, null, 8, ["name", "class"])) : a("", !0),
            (N = o(r)) != null && N.endIconSlot ? (l(), n("span", oe, [
              m(e.$slots, "endIconSlot", {}, void 0, !0)
            ])) : a("", !0)
          ])) : a("", !0)
        ], 2),
        e.helperText ? (l(), n("p", {
          key: 1,
          class: t([
            "text-xs font-normal mt-1",
            e.success && !e.disabled ? "success-msg" : e.error && !e.disabled ? "error-msg" : "default-msg",
            (M = e.classes) == null ? void 0 : M.helperText
          ])
        }, c(e.helperText), 3)) : a("", !0)
      ], 2);
    };
  }
}), te = /* @__PURE__ */ Y(se, [["__scopeId", "data-v-5775e30f"]]);
export {
  te as default
};
//# sourceMappingURL=TextField.esm.js.map
